/**
 * PG state object
 * @typedef {Object} PgState
 */

/** @type {PgState} */
export const state = {};

export const storeInLocalStorage = [];
